import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

export type FormlyPropertyValue<TDictionaryField = any> =
  | string
  | boolean
  | Array<string>
  | ((field: FormlyFieldConfig) => any)
  | ((filter: string, field: FieldTypeConfig<any>) => any)
  | Observable<any>
  | TDictionaryField;

export class FormlyExtendedPropertyToOverride<TDictionaryField = any> {
  constructor(
    public pathToProperty: string[],
    public value: FormlyPropertyValue<TDictionaryField>,
  ) {}
}

export class FormlyExtendedControlToOverride<
  TControlNames extends string,
  TDictionaryField = any,
> {
  constructor(
    public controlName: TControlNames,
    public properties: FormlyExtendedPropertyToOverride<TDictionaryField>[] = [],
  ) {}
}

export type FormlyBaseFormExpressions<
  TControlNames extends string,
  TDictionaryField = any,
> = {
  [K in TControlNames]?: {
    [property: string]:
      | string
      | boolean
      | Array<string>
      | ((field: FormlyFieldConfig) => any)
      | ((filter: string, field: FieldTypeConfig<any>) => any)
      | Observable<any>
      | TDictionaryField;
  };
};

export class FormlyBaseFormConfig<
  TControlNames extends string,
  TDictionaryField = any,
> {
  constructor(
    public fieldsToHide: TControlNames[] = [],
    public propertiesToOverride: FormlyBaseFormExpressions<
      TControlNames,
      TDictionaryField
    > = {},
    public extendedPropertiesToOverride?: FormlyExtendedControlToOverride<
      TControlNames,
      TDictionaryField
    >[],
  ) {}
}
